import React from 'react';
import { Time } from './Time';

interface DayProps {
  /**
   * The date string to be displayed. Can be any valid date string parseable by Date.parse().
   */
  date: string;

  /**
   * Optional CSS class name to apply to the time element.
   */
  className?: string;
}

/**
 * Day component for displaying the ordinal day of the month (1st, 2nd, 3rd, etc.).
 * @param props The component props.
 * @returns JSX.Element
 */
export const Day: React.FC<DayProps> = ({ date, className }) => {
  const timestamp = Date.parse(date);
  const dateObject = new Date(timestamp);
  const dayNumber = dateObject.getDate();
  const ordinalDay = getOrdinalDay(dayNumber);

  return (
    <Time date={date} className={className}>
      {ordinalDay}
    </Time>
  );
};

/**
 * Converts a day number to its ordinal representation (1st, 2nd, 3rd, etc.)
 */
function getOrdinalDay(day: number): string {
  const end = ['th', 'st', 'nd', 'rd'];
  const v = day % 100;
  return day + (end[(v - 20) % 10] || end[v] || end[0]);
}
